import React from 'react';
import './HeaderDropdown.css';

/**
 * Reusable Header Dropdown Component
 *
 * @param {boolean} isOpen - Whether dropdown is visible
 * @param {function} onMouseEnter - Handler for mouse enter
 * @param {function} onMouseLeave - Handler for mouse leave
 * @param {array} categories - Left sidebar categories [{id, label}]
 * @param {string} activeCategory - Currently active category id
 * @param {function} onCategoryHover - Handler when category is hovered
 * @param {React.ReactNode} children - Content to render in right section
 * @param {string} variant - 'default' | 'wide' - controls dropdown width
 */
const HeaderDropdown = ({
    isOpen,
    onMouseEnter,
    onMouseLeave,
    categories,
    activeCategory,
    onCategoryHover,
    children,
    variant = 'default'
}) => {
    if (!isOpen) return null;

    return (
        <div
            className={`header-dropdown ${variant === 'wide' ? 'header-dropdown--wide' : ''}`}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="header-dropdown__container">
                {/* Left Sidebar - Categories */}
                <div className="header-dropdown__sidebar">
                    {categories.map((category) => (
                        <div
                            key={category.id}
                            className={`header-dropdown__category ${activeCategory === category.id ? 'active' : ''}`}
                            onMouseEnter={() => onCategoryHover(category.id)}
                        >
                            <span>{category.label}</span>
                            <span className="header-dropdown__arrow">→</span>
                        </div>
                    ))}
                </div>

                {/* Right Content - Cards */}
                <div className="header-dropdown__content">
                    {children}
                </div>
            </div>
        </div>
    );
};

/**
 * Dropdown Card Component - Compact version
 */
export const DropdownCard = ({ href, icon, title, description, highlight = false }) => {
    return (
        <a
            href={href}
            className={`dropdown-card ${highlight ? 'dropdown-card--highlight' : ''}`}
        >
            <div className="dropdown-card__icon">{icon}</div>
            <div className="dropdown-card__text">
                <h4 className="dropdown-card__title">{title}</h4>
                <p className="dropdown-card__desc">{description}</p>
            </div>
        </a>
    );
};

/**
 * Cards Grid Container
 */
export const DropdownCardsGrid = ({ children, columns = 3 }) => {
    return (
        <div
            className="dropdown-cards-grid"
            style={{ '--grid-columns': columns }}
        >
            {children}
        </div>
    );
};

export default HeaderDropdown;
